import { SharedAppConstants } from '@tock/shared-app-constants';
import { core, toJSONArray } from '@tock/coretypes';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

export interface HubLandingResponse {
  [id: string]: dashboard.ReportQueryResponse;
}

export interface HubLandingData {
  isRequesting: boolean;
  responses: HubLandingResponse;
  dailyCovers: DayCoverCounts;
  dailyLargeParties: core.PurchaseOrder[];
}

export interface DayCoverCounts {
  [dateTime: string]: number;
}

export const initialState: HubLandingData = {
  isRequesting: false,
  responses: {},
  dailyCovers: {},
  dailyLargeParties: [],
};

export default function reducer(state = initialState, action: BaseTockAction): HubLandingData {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.HUB_LANDING_FETCH_REPORTS_FAILED:
    case AppConstants.HUB_LANDING_FETCH_DAILY_COVERS_FAILED:
    case AppConstants.HUB_LANDING_FETCH_DAILY_LARGE_PARTIES_FAILED:
      return {
        ...state,
        isRequesting: false,
      };

    case SharedAppConstants.HUB_LANDING_FETCH_REPORTS_STARTING:
    case AppConstants.HUB_LANDING_FETCH_DAILY_COVERS_STARTING:
    case AppConstants.HUB_LANDING_FETCH_DAILY_LARGE_PARTIES_STARTING:
      return {
        ...state,
        isRequesting: true,
      };

    case SharedAppConstants.HUB_LANDING_FETCH_REPORTS_DONE: {
      const responses = payload.response.reduce(
        (
          object: { [id: string]: dashboard.ReportQueryResponse },
          response: dashboard.ReportQueryResponse
        ) => {
          object[response.reportName] = response;
          return object;
        },
        {}
      );
      return {
        ...state,
        responses: { ...state.responses, ...responses },
        isRequesting: false,
      };
    }

    case AppConstants.HUB_LANDING_FETCH_DAILY_COVERS_DONE: {
      const response = toJSONArray<dashboard.CalendarDayCoverCounts>(payload);
      const dailyCovers = response.reduce<DayCoverCounts>(
        (covers, cover) => ({
          ...covers,
          [cover.dateTime]: cover.numCovers,
        }),
        {}
      );

      return {
        ...state,
        dailyCovers,
        isRequesting: false,
      };
    }

    case AppConstants.HUB_LANDING_FETCH_DAILY_LARGE_PARTIES_DONE: {
      const dailyLargeParties = toJSONArray<core.PurchaseOrder>(payload);
      return {
        ...state,
        dailyLargeParties,
        isRequesting: false,
      };
    }

    default:
      return state;
  }
}
